/* Shared audit/timeline category list and tone mapping (M-05, M-13) */
export const CATS = [
  'All', 'Organization', 'Members', 'Identity & Access', 'Licenses',
  'Branding', 'Channels', 'Storage', 'Security', 'Developer Center',
  'AI Platform', 'Settings', 'Workspace',
];

export const CAT_TONE = {
  'Organization':      'blue',
  'Members':           'green',
  'Identity & Access': 'purple',
  'Licenses':          'amber',
  'Branding':          'blue',
  'Channels':          'green',
  'Storage':           'gray',
  'Security':          'red',
  'Developer Center':  'purple',
  'AI Platform':       'amber',
  'Settings':          'gray',
  'Workspace':         'blue',
};
